import { motion } from "framer-motion";
import { Seo } from "@/components/Seo";
import { Marquee, Reveal, Dot } from "@/components/System";
import { ASSETS, LINKS } from "@/data/content";

const Launch = () => (
    <div>
        <Seo path="/launch" />
        <section className="relative flex min-h-screen flex-col overflow-hidden">
            <div className="vm-grid-bg pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" />
            <div className="pointer-events-none absolute left-1/2 top-1/3 h-[70vh] w-[110vw] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(ellipse_at_center,rgba(0,108,255,0.16),transparent_60%)]" aria-hidden="true" />

            <div className="relative mx-auto flex w-full max-w-5xl flex-1 flex-col items-center justify-center px-4 pb-20 pt-32 text-center sm:px-6">
                <motion.div
                    initial={{ opacity: 0, scale: 0.85 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    className="relative"
                >
                    <div className="absolute -inset-6 rounded-full border border-[#00D9FF]/15 vm-spin-slow" aria-hidden="true" />
                    <img
                        src={ASSETS.logo}
                        alt="AgentVM logo"
                        className="vm-float h-36 w-36 object-cover shadow-[0_0_100px_rgba(0,140,255,0.4)] sm:h-44 sm:w-44"
                    />
                </motion.div>

                <div className="mt-10 overflow-hidden">
                    <motion.h1
                        initial={{ y: "115%" }}
                        animate={{ y: 0 }}
                        transition={{ delay: 0.3, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        className="text-4xl font-bold tracking-tight text-[#F5F9FF] sm:text-6xl"
                    >
                        AGENTVM IS <span className="text-[#00D9FF] vm-glow">ONLINE.</span>
                    </motion.h1>
                </div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.7 }}
                    className="mt-5 flex items-center gap-3 font-mono text-xs tracking-[0.3em] text-[#B8C7D9]"
                >
                    <Dot /> PRIVATE INTELLIGENCE. PROVABLE ACTION.
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.9, duration: 0.7 }}
                    className="mt-10 flex flex-wrap justify-center gap-3"
                >
                    <a
                        href={LINKS.buy}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="launch-buy"
                        className="border border-[#1688FF]/70 bg-[#006CFF]/25 px-7 py-3 font-mono text-xs tracking-[0.26em] text-[#F5F9FF] transition-all hover:bg-[#006CFF]/45 hover:shadow-[0_0_30px_rgba(0,108,255,0.45)]"
                    >
                        BUY $AGENTVM ↗
                    </a>
                    <span
                        data-testid="launch-chart"
                        title="PAIR DATA NOT AVAILABLE"
                        className="cursor-not-allowed border border-[rgba(0,217,255,0.2)] px-7 py-3 font-mono text-xs tracking-[0.26em] text-[#B8C7D9]/40"
                    >
                        OPEN CHART — DATA NOT AVAILABLE
                    </span>
                    <a
                        href={LINKS.x}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="launch-x"
                        className="border border-[rgba(0,217,255,0.3)] px-7 py-3 font-mono text-xs tracking-[0.26em] text-[#B8C7D9] transition-colors hover:border-[#00D9FF]/70 hover:text-[#00D9FF]"
                    >
                        FOLLOW X ↗
                    </a>
                </motion.div>

                <Reveal delay={0.4} className="mt-16 w-full">
                    <div className="vm-panel scanlines relative overflow-hidden">
                        <img
                            src={ASSETS.banner}
                            alt="AgentVM command center visual"
                            className="h-48 w-full object-cover object-center opacity-80 sm:h-64"
                            loading="lazy"
                        />
                    </div>
                </Reveal>
            </div>

            <Marquee items={["AGENTVM IS ONLINE", "PRIVATE INTELLIGENCE. PROVABLE ACTION.", "THE VERIFIABLE RUNTIME FOR AI AGENTS", "ARC ECONOMIC LAYER"]} />
        </section>
    </div>
);

export default Launch;
